import { enqueueSnackbar } from 'notistack'
import { useState } from 'react'
import { FieldErrors } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { mapGraphQLErrors } from 'providers/tanstack-query/errors'
import { useMutation } from 'providers/tanstack-query/useMutation'
import { CommonProps } from '../../../types'
import { Schema } from '../../schema'
import { toDTO } from './api/mapper'
import { CONNECT_BANNER_AND_OUTSTREAM_TO_GAM } from './api/mutation'
import { Data, Variables } from './api/types'
import { UseConnectBannerAndOutstreamToGam } from './types'

export const useConnectBannerAndOutstreamToGam = ({
  setIsDialogOpen,
}: Pick<CommonProps, 'setIsDialogOpen'>): UseConnectBannerAndOutstreamToGam => {
  const { workspaceId } = useWorkspaceParam()
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'googleAdManagerConnection.setupPrebidStack.form',
  })
  const [errors, setErrors] = useState<FieldErrors<Schema>>({})

  const { isPending, mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: CONNECT_BANNER_AND_OUTSTREAM_TO_GAM,
    onCompleted: async ({ connectBannerAndOutstreamToGam: { errors } }: Data): Promise<void> => {
      if (errors && errors.length > 0) {
        setErrors(mapGraphQLErrors(errors))
        enqueueSnackbar(t('notification.error'), { variant: 'error' })
      } else {
        enqueueSnackbar(t('notification.success'), { variant: 'success' })
      }

      setIsDialogOpen(false)
    },
    queriesToInvalidate: ['getGoogleAdManagerSetupOrders'],
  })

  const connect = (data: Schema): void =>
    void mutateAsync({
      input: {
        ...toDTO(data),
        workspaceId,
      },
    })

  return {
    connect,
    errors,
    loading: isPending,
  }
}
